import React from 'react';
import Grid from '@material-ui/core/Grid';
import GridWrapper from './GridWrapper';
import BrandLoader from './BrandLoader';

interface IProps {
  /** Width and height of the loader in px. */
  size?: number;
}

const Loading = ({ size = 64 }: IProps) => (
  <GridWrapper padding={24}>
    <Grid
      container
      spacing={0}
      justify="center"
      alignItems="center"
      alignContent="center"
    >
      <BrandLoader size={size} />
    </Grid>
  </GridWrapper>
);
export default Loading;
